import Vue from "vue";
import Vuex from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import Swal from 'sweetalert2';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    IReencauche: {},
    IReencauchabilidad: {},
    MarcasNeumatico: [],
    MesesCostoPorKilometro: [],
    CostoPorKilometro: [],
    IndicesReencauchePorMes: [],
    IndicesReencauchabilidadPorMes: [],
    DatosTotalesAnualReencauche: {},
    DatosTotalesMensualReencauche: [],
    DatosTotalesAnualReencauchabilidad: {},
    DatosTotalesMensualReencauchabilidad: [],
    DatosTotalesAnualCosto: {},
    DatosTotalesMensualCosto: [],
  },
  getters: {},
  mutations: {
    LlenarIReencauche(state, payload) {
      state.IReencauche = payload;
    },
    LlenarIReencauchabilidad(state, payload) {
      state.IReencauchabilidad = payload;
    },
    LlenarMarcasNeumatico(state, payload) {
      state.MarcasNeumatico = payload;
    },
    LlenarCostoPorKilometro(state, payload) {
      state.CostoPorKilometro = payload;
    },
    LlenarMesesCostoPorKilometro(state, payload) {
      const lista = Array.isArray(payload) ? payload.slice() : (typeof payload === 'object' && payload !== null ? Object.values(payload) : []);
      state.MesesCostoPorKilometro = lista.sort((a, b) => parseInt(a) - parseInt(b));
    },
    LlenarIndicesReencauchePorMes(state, payload) {
      state.IndicesReencauchePorMes = payload;
    },
    LlenarIndicesReencauchabilidadPorMes(state, payload) {
      state.IndicesReencauchabilidadPorMes = payload;
    },
    LlenarDatosTotalesAnualReencauche(state, payload) {
      state.DatosTotalesAnualReencauche = payload || {};
    },
    LlenarDatosTotalesMensualReencauche(state, payload) {
      state.DatosTotalesMensualReencauche = payload || [];
    },
    LlenarDatosTotalesAnualReencauchabilidad(state, payload) {
      state.DatosTotalesAnualReencauchabilidad = payload || {};
    },
    LlenarDatosTotalesMensualReencauchabilidad(state, payload) {
      state.DatosTotalesMensualReencauchabilidad = payload || [];
    },
    LlenarDatosTotalesAnualCosto(state, payload) {
      state.DatosTotalesAnualCosto = payload || {};
    },
    LlenarDatosTotalesMensualCosto(state, payload) {
      state.DatosTotalesMensualCosto = payload || [];
    },
  },
  actions: {
    messageErrorAlert: function () {
      Swal.fire({
        title: "Upps, algo paso!",
        text: "Servidor desconectado, por favor actualice la ventana!",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Actualizar",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
        backdrop: `
          rgba(255,0,0,0.1)
          left top
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    },

    cargarMarcasVehiculo: async function ({ commit, dispatch }) {
      try {
        const url = "neumaticomarca/index";
        let data = { id_cliente: localStorage.getItem("idcliente") };
        await axios
          .post(url, data)
          .then((response) => {
            let marcas = [];
            response.data.success.resultado.forEach((element, i) => {
              marcas[i] = { value: element.id, text: element.descripcion };
            });
            commit("LlenarMarcasNeumatico", marcas);
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    reporteCostoPorKilometro: async function ({ commit, dispatch }, item) {
      try {
        const url = "indicador/costo_por_kilometro";
        let data = {
          id_cliente: localStorage.getItem("idcliente"),
          marca: item.marca,
          year: item.anio,
          unidadmedida: item.unidadmedida,
        };
        await axios
          .post(url, data)
          .then((response) => {
            const rawCostos = response.data.success.costos || [];
            const mesesRaw = response.data.success.meses || [];
            const meses = (Array.isArray(mesesRaw) ? mesesRaw.slice() : Object.values(mesesRaw)).sort((a, b) => parseInt(a) - parseInt(b));

            let listaCostos = [];
            if (Array.isArray(rawCostos)) {
              listaCostos = rawCostos;
            } else if (typeof rawCostos === 'object' && rawCostos !== null) {
              Object.values(rawCostos).forEach(arr => {
                if (Array.isArray(arr)) {
                  listaCostos.push(...arr);
                }
              });
            }

            commit("LlenarCostoPorKilometro", rawCostos);
            commit("LlenarMesesCostoPorKilometro", meses);

            // Calcular KPI por mes a partir de los costos
            const datosMensuales = meses.map((mes) => {
              let sumaCosto = 0, countCosto = 0;
              let sumaPrecio = 0, countPrecio = 0;
              let sumaRend = 0, countRend = 0;
              listaCostos.forEach((costo) => {
                const valCosto = parseFloat(costo["indicador_mes_" + mes]);
                if (!isNaN(valCosto)) { sumaCosto += valCosto; countCosto++; }
                const valPrecio = parseFloat(costo["precio_mes_" + mes]);
                if (!isNaN(valPrecio)) { sumaPrecio += valPrecio; countPrecio++; }
                const valRend = parseFloat(costo["rendimiento_mes_" + mes]);
                if (!isNaN(valRend)) { sumaRend += valRend; countRend++; }
              });
              return {
                mes: parseInt(mes),
                costo: countCosto > 0 ? parseFloat((sumaCosto / countCosto).toFixed(4)) : null,
                precio: countPrecio > 0 ? parseFloat((sumaPrecio / countPrecio).toFixed(2)) : null,
                rendimiento: countRend > 0 ? parseFloat((sumaRend / countRend).toFixed(2)) : null,
              };
            });

            // Calcular KPI promedio anual
            let sumaAnual = 0, countAnual = 0;
            let sumaPrecioAnual = 0, countPrecioAnual = 0;
            let sumaRendAnual = 0, countRendAnual = 0;
            datosMensuales.forEach((d) => {
              if (d.costo !== null) { sumaAnual += d.costo; countAnual++; }
              if (d.precio !== null) { sumaPrecioAnual += d.precio; countPrecioAnual++; }
              if (d.rendimiento !== null) { sumaRendAnual += d.rendimiento; countRendAnual++; }
            });
            const datoAnual = {
              costo: countAnual > 0 ? parseFloat((sumaAnual / countAnual).toFixed(4)) : null,
              precio: countPrecioAnual > 0 ? parseFloat((sumaPrecioAnual / countPrecioAnual).toFixed(2)) : null,
              rendimiento: countRendAnual > 0 ? parseFloat((sumaRendAnual / countRendAnual).toFixed(2)) : null,
            };

            commit("LlenarDatosTotalesAnualCosto", datoAnual);
            commit("LlenarDatosTotalesMensualCosto", datosMensuales);
          })
          .catch((error) => {
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    reporteIndiceReencauche: async function ({ commit, dispatch }, year) {
      try {
        const url = "indicador/indice_reencauche";
        let data = {
          id_cliente: localStorage.getItem("idcliente"),
          year: year,
        };
        await axios
          .post(url, data)
          .then((response) => {
            commit("LlenarIReencauche", response.data.success.criterio);
            commit(
              "LlenarIndicesReencauchePorMes",
              response.data.success.indicesmensuales
            );
            commit(
              "LlenarDatosTotalesAnualReencauche",
              response.data.success.datostotalesAnual
            );
            commit(
              "LlenarDatosTotalesMensualReencauche",
              response.data.success.datostotalesMensual
            );
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    reporteIndiceReencauchabilidad: async function ({ commit, dispatch }, year) {
      try {
        const url = "indicador/indice_reencauchabilidad";
        let data = {
          id_cliente: localStorage.getItem("idcliente"),
        };
        if (year && typeof year === 'object') {
          data.year = year.anio;
          if (year.marca) data.id_marca = year.marca;
          if (year.modelo) data.id_modelo = year.modelo;
          if (year.medida) data.id_medida = year.medida;
        } else {
          data.year = year;
        }
        await axios
          .post(url, data)
          .then((response) => {
            commit("LlenarIReencauchabilidad", response.data.success.criterio);
            commit(
              "LlenarIndicesReencauchabilidadPorMes",
              response.data.success.indicesmensuales
            );
            commit(
              "LlenarDatosTotalesAnualReencauchabilidad",
              response.data.success.datostotalesAnual
            );
            commit(
              "LlenarDatosTotalesMensualReencauchabilidad",
              response.data.success.datostotalesMensual
            );
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },
  },
};
